import React from 'react';
import styled from 'styled-components';
import { CheckedSquare } from '../Components/Icons';
import { MoveDownIcon } from '../Components/Icons';
import { AlertIcon } from '../Components/Icons';
import Button from '../Components/Button';
import { RECEIVER_ACTIONS, SENDER_ACTIONS } from '../models/Engine';
import { PageType } from '../models/PageData';
const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  min-height: 100vh;
  h1 {
    font-size: 54px;
    text-align: center;
  }
  h4 {
    font-size: 36px;
    text-align: center;
  }
  .status {
    display: grid;
    grid-gap: 12px;
    .info {
      background-color: white;
      color: black;
      padding: 12px 8px;
      text-align: center;
      font-size: 36px;
      font-weight: 600;
      display: flex;
      grid-gap: 12px;
      justify-content: center;
      align-items: center;
      svg {
        color: green;
        width: 32px;
        height: 32px;
        color: red;
      }
      &.success {
        svg {
          color: green;
        }
      }
    }
    .next-step-icon {
      color: blue;
      display: block;
      margin: 0 auto;
      width: 36px;
      height: 36px;
    }
  }
  .actions {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 48px;
    position: relative;
    z-index: 100;
    button {
      width: 100%;
      font-size: 18px;
      padding: 12px 4px;
    }
  }
`;

const Setup: React.FC = () => {
  const data = window.DATA;
  return (
    <Wrapper>
      <div>
        <h1>{data?.inventory ? 'ADMIN CONTROLS' : 'SETUP DEVICE'}</h1>
        <h4>{data?.deviceId ?? 'ERROR LOADING DEVICE ID'}</h4>
      </div>
      <section className="status">
        <div className={data?.isExperienceConfigured ? 'info success' : 'info'}>
          {data?.isExperienceConfigured ? <CheckedSquare /> : <AlertIcon />}ASSIGN EXPERIENCE
        </div>
        <MoveDownIcon className="next-step-icon" />
        <div className={data?.isChannelsConfigured ? 'info success' : 'info'}>
          {data?.isChannelsConfigured ? <CheckedSquare /> : <AlertIcon />}CONFIGURE CHANNEL
        </div>
        <MoveDownIcon className="next-step-icon" />
        <div className={data?.products ? 'info success' : 'info'}>{data?.products ? <CheckedSquare /> : <AlertIcon />}GET PRODUCTS</div>
        <MoveDownIcon className="next-step-icon" />
        <div className={data?.inventory ? 'info success' : 'info'}>{data?.inventory ? <CheckedSquare /> : <AlertIcon />}SETUP INVENTORY</div>
      </section>
      <section className="actions">
        <Button
          onClick={() => {
            window.SENDER({ type: SENDER_ACTIONS.CONFIGURE_CHANNELS, payload: '' });
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_DEFAULT, message: 'CONFIGURING VEND CHANNELS' },
            });
          }}>
          CONFIGURE CHANNELS
        </Button>
        <Button
          onClick={() => {
            window.SENDER({ type: SENDER_ACTIONS.GET_PRODUCTS_ONLINE, payload: '' });
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_DEFAULT, message: 'FETCHING PRODUCTS FROM PORTAL' },
            });
          }}
          disabled={!data || !data.experienceId}>
          GET PRODUCTS FROM PORTAL
        </Button>
        <Button
          onClick={() =>
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_INVENTORY },
            })
          }
          disabled={!data || !data.products || !data?.isChannelsConfigured}>
          SET INVENTORY
        </Button>
        <Button
          onClick={() => {
            window.SENDER({ type: SENDER_ACTIONS.GET_INVENTORY_ONLINE, payload: '' });
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_DEFAULT, message: 'FETCHING INVENTORY FROM PORTAL' },
            });
          }}
          disabled={!data || !data.isChannelsConfigured || !data.products}>
          GET INVENTORY FROM PORTAL
        </Button>
        <Button
          onClick={() =>
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_ADMIN_VEND },
            })
          }
          disabled={!data || !data.inventory}>
          TEST VEND
        </Button>
        <Button
          onClick={() =>
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_IDLE },
            })
          }
          disabled={!data || !data.inventory || !data.isExperienceConfigured}>
          GO TO EXPERIENCE
        </Button>
        <Button onClick={() => window.SENDER({ type: SENDER_ACTIONS.REINITIALIZE_MACHINE, payload: '' })}>RESTART APPLICATION</Button>
        <Button
          onClick={() => {
            window.SENDER({ type: SENDER_ACTIONS.GET_MACHINE_STATUS, payload: '' });
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_DEFAULT, message: 'GETTING MACHINE STATUS' },
            });
          }}>
          CHECK MACHINE STATUS
        </Button>
        <Button
          onClick={() => {
            window.SENDER({ type: SENDER_ACTIONS.CLOSE_APPLICATION, payload: '' });
            window.RECEIVER({
              type: RECEIVER_ACTIONS.CHANGE_PAGE,
              payload: { page: PageType.SCREEN_DEFAULT, message: 'SHUTTING DOWN' },
            });
          }}>
          CLOSE APPLICATION
        </Button>
      </section>
    </Wrapper>
  );
};

export default Setup;
